const INIT_STATE = {
	messages:[],
  currentMessage: null,
  openMessageModal: false
};


export default (state = INIT_STATE, action) =>{
    switch(action.type) {
        case 'message':
          state.messages = action.payload.messages;
        return {...state};

        case 'currentMessage':
          state.currentMessage = action.payload.currentMessage;
        return {...state};
        
        case 'openMessageModal':
          state.openMessageModal = !state.openMessageModal;
        return {...state};

        default:
      return { ...state };
    }
}